const APP_FLAVOR_CONFIGS = {
  KASA: {
    id: "KASA",
  },
};

export { APP_FLAVOR_CONFIGS };
